import { Action, createReducer, on } from '@ngrx/store';
import * as inventoryActions from './inventory.actions';
import { InventoryItemType } from 'src/app/inventory/inventory-itemtype';
import { HiveApplication } from 'src/app/applications/hive-application';
import { InventoryRecord } from 'src/app/inventory/inventory-record';

export interface InventoryState {
  // Item Type hierarchy
  types: InventoryItemType[];

  // Loading flag for types
  typesLoaded: boolean;

  // Applications
  applications: HiveApplication[];

  // Purchase records
  records: InventoryRecord[];
}

export const initialState = {
  types: [],
  typesLoaded: false,

  applications: [],
  records: [],
} as InventoryState;

const inventoryReducer = createReducer<InventoryState>(
  initialState,

  on(inventoryActions.loadTypesOk, (state, { types }) => ({
    ...state,
    types: types,
    typesLoaded: true,
  })),
  on(inventoryActions.loadTypesFailed, (state) => ({
    // TODO - what to do
    ...state,
  })),
  on(inventoryActions.loadApplicationsOk, (state, { applications }) => ({
    ...state,
    applications: applications,
    // loaded: true,
  })),
  on(inventoryActions.loadApplicationsFailed, (state) => ({
    // TODO - what to do
    ...state,
  })),

  on(inventoryActions.loadRecordsOk, (state, { records }) => ({
    ...state,
    records: records,
    // loaded: true,
  })),
  on(inventoryActions.loadRecordsFailed, (state) => ({
    // TODO - what to do
    ...state,
  }))
);

export function reducer(state: InventoryState | undefined, action: Action) {
  return inventoryReducer(state, action);
}
